import { TimesHttpHelper, NO_DATA_MESSAGE } from '@usas/ui-web/utils/HttpHelper';

const GetTimeStandardAgeGroupEventStandardData = (timeStandardAgeGroupIds, state, setState) => {
  if (state.isArrayLoading !== true && !state.message) {
    const newState = {
      ...state,
      isArrayLoading: true,
      isArrayLoaded: false,
      message: 'Loading...'
    };
    setState(newState);

    const url = `/TimeStandardAgeGroup/${encodeURIComponent(timeStandardAgeGroupIds)}/EventStandard`;
    TimesHttpHelper(url, 'GET')
      .then((arrayData) => {
        if (!arrayData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            isArrayLoading: false,
            isArrayLoaded: true,
            arrayData,
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isArrayLoading: false,
          isArrayLoaded: false,
          message: message
        });
      });
  }
};

export default GetTimeStandardAgeGroupEventStandardData;